import { Space, Typography } from "antd";
import { FC } from "react";

const PageTitle: FC<{ title: string; count?: number | string,textClassNames?:string }> = ({
  title,
  count,
  textClassNames
}) => {
  const { Text } = Typography;
  return (
    <>
      <Text className="">
        <Space>
          <span className={`!text-lg  !font-bold ${textClassNames}`}>{title}</span>
          {
            (count===0||count)&&
          <span className="!text-gray-400 !text-xs md:!text-blase">({count || "0"})</span>
          }
        </Space>
      </Text>
    </>
  );
};

export default PageTitle;
